import {Box, Typography} from "@mui/material";
import {codecs, resolutions} from "./AssetsConfig";
import {VideoJob} from "./VideoJob";

interface IVideoJobs {
    config: any
    project: string
}
export function VideoJobs({config, project}: IVideoJobs) {
    return (
        <Box>
            <Typography>
                These are the transcoding jobs that will be undertaken by the automated build process. Source files are
                pulled down from frame.io and converted to this format, then uploaded to the AWS into corresponding
                folders to the source folder.
            </Typography>
            <Box display="flex">
                {codecs.map(codec =>
                    <Box display="flex" flexDirection="column" key={codec}>
                        {resolutions.map(resolution =>
                            <VideoJob config={config} project={project} key={resolution}
                                      resolution={`${codec}_${resolution}`}/>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    );
}